import { Section10Images } from '../../../assets/OurStoryImages/Section10'

const imageLayoutStyles =
  'flex flex-col items-center gap-6 lg:flex-row lg:justify-between lg:self-stretch lg:w-[864px] 2xl:w-[1280px] 3xl:w-[1680px]'
const image_1_2_Styles = 'h-[42px] 2xl:h-[64px] 3xl:h-[74px]'
const image_5_6_7_8_9_Styles = 'h-[72px] 2xl:h-[115px] 3xl:h-[136px]'
const image_10_12_13_Styles = 'h-[36px] 2xl:h-[60px] 3xl:h-[74px]'

export const Section10 = () => {
  return (
    <>
      <div className='py-25 flex flex-col items-center lg:py-52 3xl:py-80'>
        <h1 className='text-2xl xl:text-3xl 2xl:text-4xl 3xl:text-[64px] font-medium text-[#101828] leading-6 tracking-[0.4px]'>
          In the media
        </h1>
        <div className='space-y-20 pt-15 3xl:pt-30'>
          <div className={imageLayoutStyles}>
            <img
              src={Section10Images.Media1}
              alt='Todays Conveyancer Logo'
              className={image_1_2_Styles}
            />
            <img
              src={Section10Images.Media2}
              alt='Todays Family Lawyer Logo'
              className={image_1_2_Styles}
            />
            <img
              src={Section10Images.Media3}
              alt='Information Age Logo'
              className='h-[29px] 2xl:h-[44px] 3xl:h-[51px]'
            />
            <img
              src={Section10Images.Media4}
              alt='Global Legal Post Logo'
              className='h-[29px] 2xl:h-[48px] 3xl:h-[51px]'
            />
          </div>
          <div className={imageLayoutStyles}>
            <img
              src={Section10Images.Media5}
              alt='B Media Logo'
              className={image_5_6_7_8_9_Styles}
            />
            <img
              src={Section10Images.Media6}
              alt='Challenge Works Logo'
              className={image_5_6_7_8_9_Styles}
            />
            <img
              src={Section10Images.Media7}
              alt='Artificial Lawyer Logo'
              className={image_5_6_7_8_9_Styles}
            />
            <img
              src={Section10Images.Media8}
              alt='Law Society Gazette Logo'
              className={image_5_6_7_8_9_Styles}
            />
            <img
              src={Section10Images.Media9}
              alt='Leigh Day Logo'
              className={image_5_6_7_8_9_Styles}
            />
          </div>
          <div className={imageLayoutStyles}>
            <img
              src={Section10Images.Media10}
              alt='Solicitors Regulation Authority Logo'
              className={image_10_12_13_Styles}
            />
            <img
              src={Section10Images.Media11}
              alt='Gov UK Logo'
              className='h-[25px] 2xl:h-[41px] 3xl:h-[50px]'
            />
            <img
              src={Section10Images.Media12}
              alt='Legal Futures Logo'
              className={image_10_12_13_Styles}
            />
            <img
              src={Section10Images.Media13}
              alt='Startups Magazine Logo'
              className={image_10_12_13_Styles}
            />
          </div>
        </div>
      </div>
    </>
  )
}
